import { render } from "./club-detail.template.html?vue&type=template&id=5fd49de8&scoped=true"
import script from "./ClubDetail.vue?vue&type=script&lang=ts"
export * from "./ClubDetail.vue?vue&type=script&lang=ts"

import "./ClubDetail.vue?vue&type=style&index=0&id=5fd49de8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5fd49de8"

export default script